export default __webpack_public_path__ + "static/media/Blooded Straps of the Plains.1ef7c7bf.jpg";